import { render, staticRenderFns } from "./ForgotPasswordSuccess.vue?vue&type=template&id=8864c83e"
import script from "./ForgotPasswordSuccess.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports